import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="bg-white px-5 py-14 md:py-20" data-id="element-291" data-mp="3mepjurjhftqe">
      <div className="mx-auto max-w-6xl" data-id="element-292" data-mp="3r7se71w3377n">
        <SectionHeading title={<>
              What Nurses Are Saying About the <span className="text-teal" data-id="element-294" data-mp="y4kfnbcuey">Blueprint™</span>
            </>} data-id="element-293" data-mp="3r9locr5wo9ke" />

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-295" data-mp="40zu5qfrxxdv">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-canvas p-6 ring-1 ring-navy/5" data-id="element-296" data-mp="92p75bmk4l4l">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-297" data-mp="e07gv48ef4dn">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-298" data-mp="2fs3rmbmqsa7d" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-[16px] leading-relaxed text-navy" data-id="element-299" data-mp="1slazpmzbixb8">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-300" data-mp="1nt13xqbiv311">
                <img src={t.image} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-white" loading="lazy" data-id="element-301" data-mp="1ity90yp9ad6s" />
                <div data-id="element-302" data-mp="1euz43e3iygfc">
                  <p className="flex items-center gap-1 font-extrabold text-navy" data-id="element-303" data-mp="1erbdontdma4u">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 text-teal" aria-label="Verified buyer" data-id="element-304" data-mp="26kk3toa920yu" />
                  </p>
                  <p className="text-sm text-navy/65" data-id="element-305" data-mp="22hxjs9jtlkc7">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCTA label="Join These Nurses" data-id="element-306" data-mp="1xlyoe202r22a" />
      </div>
    </section>;
}